module.exports = __webpack_public_path__ + "img/Play-white.8d7b1214.svg";